module.exports = __webpack_public_path__ + "img/fin-banner_fade.fa5adf77.svg";